import { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

interface PasswordInputProps {
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  showPassword: boolean;
  onTogglePassword: () => void;
  error?: string;
  touched?: boolean;
}

const PasswordInput: FunctionComponent<PasswordInputProps> = ({
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  showPassword,
  onTogglePassword,
  error,
  touched,
}) => {
  return (
    <div className="mb-4 auth-field-container">
      <div className="position-relative w-100" style={{ maxWidth: '440px' }}>
        <input
          type={showPassword ? "text" : "password"}
          className="auth-text-18 password-input"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {/* [2026-02-07] style-extraction: moved inline styles to _auth.scss */}
        <button
          type="button"
          className="btn p-0 border-0 bg-transparent position-absolute password-toggle-btn password-toggle-btn-positioned"
          onClick={onTogglePassword}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
        </button>
      </div>
      {touched && error && (
        <div className="text-danger mt-1 text-center u-Label-12 auth-error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
